import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { DatePicker, Row, Col } from 'components/ui';

export default function TargetDateSelector() {
  const { control } = useFormContext();

  return (
    <Row gutter={8}>
      <Col span={15}>
        <h5>Target Date</h5>
        <Controller
          control={control}
          name="targetDate"
          render={({ field, fieldState }) => {
            return (
              <DatePicker
                helperText={fieldState.error?.message}
                placeholder="Select target date"
                showTime
                validationStatus={fieldState.error ? 'error' : ''}
                onChange={date => field.onChange(date && date.toISOString())}
                onOk={date => field.onChange(date.toISOString())}
              />
            );
          }}
        />
      </Col>
    </Row>
  );
}
